import { API_ENDPOINT_URL } from '../env';

export const apiUrls = {
    getPageUrl: (primaryPath, secondaryPath) => {
        return `${API_ENDPOINT_URL}/api/v2/page/public/${primaryPath}/${secondaryPath}`;
    },
    getDonationUrl: () => {
        return `${API_ENDPOINT_URL}/api/v2/donation`;
    },
    getDonationV3Url: () => {
        return `${API_ENDPOINT_URL}/api/v3/donation`;
    },
    getDonationCoverFeeUrl(orgPath, campaignPath, amount) {
        return `${API_ENDPOINT_URL}/api/v2/donation/fee/${orgPath}/${campaignPath}?amount=${amount}&coverFee=true`;
    },
    getDonationSubscriptionUrl() {
        return `${API_ENDPOINT_URL}/api/v2/donationSubscription`;
    },
    getDonationSubscriptionV3Url() {
        return `${API_ENDPOINT_URL}/api/v3/donationSubscription`;
    },
    getDonationSubscriptionCoverFeeUrl(orgPath, amount) {
        return `${API_ENDPOINT_URL}/api/v2/donationSubscription/fee/${orgPath}?amount=${amount}&coverFee=true`;
    },
    getDonationIntentUrl() {
        return `${API_ENDPOINT_URL}/api/v2/donation/intent`;
    },
    getDonationIntentPublicUrl(guid) {
        return `${API_ENDPOINT_URL}/api/v2/donation/intent/public/${guid}`;
    },
}